import { getJSON } from 'utils/fetchUtils'

export function getConfigurations() {
  return getJSON(`/configurations/`)
}
